export default "__VITE_ASSET__BPAPEtp7__"